import { forwardRef, memo } from 'react';
import { FormattedMessage } from 'react-intl';
// Material UI imports
import Alert, { type AlertColor, type AlertProps } from '@mui/material/Alert';
// local imports
import { type Values } from '../helpers/intl';
// SCSS imports
import { square } from './InlineAlert.module.scss';

type InlineAlertProps = {
  readonly severity: AlertColor;
  readonly message: string;
  readonly values?: Values;
  readonly flat?: boolean;
  readonly sx?: AlertProps['sx'];
};

const InlineAlert = forwardRef<HTMLDivElement, InlineAlertProps>(({
  severity,
  message,
  values,
  flat = false,
  sx
}, ref) => (
  <Alert
      ref={ref}
      severity={severity}
      variant="standard"
      elevation={flat ? 0 : undefined}
      square={flat}
      className={flat ? square : undefined}
      sx={sx}
  >
    <FormattedMessage id={message} values={values}/>
  </Alert>
));

InlineAlert.displayName = 'InlineAlert';

export default memo(InlineAlert);
